import { render, staticRenderFns } from "./PostDetailDialog.vue?vue&type=template&id=5a3c050e&scoped=true"
import script from "./PostDetailDialog.vue?vue&type=script&lang=js"
export * from "./PostDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PostDetailDialog.vue?vue&type=style&index=0&id=5a3c050e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c050e",
  null
  
)

export default component.exports